/* oa.js: shared behaviour for the oa-* sections (/pages/hyt-bp-oa and /pages/hyt-bp-oa-pud).
   One IIFE, vanilla, loaded with defer. Globals only under window.__OA_*.
   - buy(): clear cart, ONE /cart/add.js (bundle + plan + _hbo_src, gifts, tagged sampler), retry
     on 422 without the sampler then bundle alone, then the bbfix drawer.
   - _hbo_src tagger (port of hbo-hero): trusted taps on [data-oa-tag] only. No network, no storage.
   - layers: [data-oa-sheet] opens the offer sheet, [data-oa-modal-open="id"] opens a modal.
   - sticky bar visibility, Alia guard, accordion / swiper / lazy-video helpers.
   Nothing here calls cart/* on page load. */
(function () {
  'use strict';
  if (window.__OA_BOOTED) return;
  window.__OA_BOOTED = true;

  var d = document;
  var html = d.documentElement;
  var SAMPLER = 54770520883572;

  /* ---------------- config: every [data-oa-config] JSON tag, merged in page order (the buy box's
     own tag comes after oa-head's, so its block settings win). */
  var C = { page: 'hyt-bp-oa', vid: 0, plan: 0, gifts: [], sticks: 0, clear: true, checkout: false, errText: '' };
  function readConfig() {
    var tags = d.querySelectorAll('script[data-oa-config]');
    for (var i = 0; i < tags.length; i++) {
      try {
        var o = JSON.parse(tags[i].textContent);
        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k) && o[k] !== null && o[k] !== '') C[k] = o[k];
      } catch (e) {}
    }
    C.vid = +C.vid || 0;
    C.plan = +C.plan || 0;
    C.sticks = +C.sticks || 0;
    C.gifts = (C.gifts || []).map(function (g) { return +g; }).filter(function (g) { return g && g !== SAMPLER; });
  }
  readConfig();
  window.__OA_CFG = C;

  /* ---------------- Alia guard: the scratch popup (PC40) must not open on this page, unless the
     page's oa-hero has "Hide the Alia popup" unticked (oa-head then sets __OA_ALIA_ON). */
  function aliaGuard() {
    if (window.__OA_ALIA || window.__OA_ALIA_ON) return;
    window.__OA_ALIA = true;
    window.Alia = window.Alia || {};
    try { window.Alia.suppress = true; } catch (e) {}
    function sweep() {
      var kids = d.body ? d.body.children : [], hit = false;
      for (var i = kids.length - 1; i >= 0; i--) {
        var id = kids[i].id || '';
        if (id.indexOf('alia-root') === 0) { kids[i].parentNode.removeChild(kids[i]); hit = true; }
      }
      /* Alia locks body scroll even with its popup gone; release any inline lock our sheet or the drawer does not own. */
      if (d.body && d.body.style.overflow === 'hidden' && !html.classList.contains('oa-lock') && !d.querySelector('.bbfix-cart__bg.open')) {
        d.body.style.overflow = '';
        html.style.overflow = '';
        d.body.style.position = '';
      }
    }
    sweep();
    if (!window.MutationObserver || !d.body) return;
    var mo = new MutationObserver(sweep);
    mo.observe(d.body, { childList: true, attributes: true, attributeFilter: ['style'] });
  }
  aliaGuard();

  /* ---------------- CTA source tagger (port of hbo-hero, 2026-09-25). A capture listener notes every
     REAL tap (isTrusted) on an element carrying data-oa-tag. Taps inside the sheet update only the
     final tap; taps outside also update "last" and the trail of 5. Sticky taps get @vis (JS
     visibility mode) or @css (the CSS 3s fallback was showing it). */
  var SRC = window.__OA_SRC = { last: '', fin: '', trail: [] };
  function srcOf(el) {
    if (!el || !el.closest) return '';
    var t = el.closest('[data-oa-tag]');
    if (!t) return '';
    var id = String(t.getAttribute('data-oa-tag') || '').trim();
    if (!id) return '';
    var stk = t.closest('.oa-stk');
    if (stk && id.indexOf('@') < 0) id += stk.classList.contains('oa-stk--js') ? '@vis' : '@css';
    return id.slice(0, 40);
  }
  window.__OA_SRC_OF = srcOf;
  /* Swipe depth (spec S3: 4 next = a full swipe). A finger swipe is not a tap, so the tagger never
     sees it. A swiper root with data-oa-swipe-tag="oa:deck:swipe" (and optional data-oa-swipe-at,
     default 4) adds that slug to the trail once, when the user reaches that slide. It does not change
     "last" or "final", so the tap that led to the buy is still what those two fields report. */
  d.addEventListener('oa:slide', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    var slug = el.getAttribute('data-oa-swipe-tag');
    if (!slug || el.__oaSwipeTagged) return;
    var at = parseInt(el.getAttribute('data-oa-swipe-at'), 10) || 4;
    if (!e.detail || e.detail.index < at) return;
    el.__oaSwipeTagged = true;
    SRC.trail.push(String(slug).slice(0, 40));
    if (SRC.trail.length > 5) SRC.trail.shift();
  }, true); /* capture: oa:slide does not bubble */
  d.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var id = '';
    try { id = srcOf(e.target); } catch (err) {}
    if (!id) return;
    SRC.fin = id;
    if (!(e.target.closest && e.target.closest('.oa-sheet'))) {
      SRC.last = id;
      SRC.trail.push(id);
      if (SRC.trail.length > 5) SRC.trail.shift();
    }
  }, true);
  function srcValue() {
    return [C.page || 'hyt-bp-oa', SRC.last || 'none', SRC.fin || 'none', SRC.trail.join('>')].join('|').slice(0, 250);
  }

  /* ---------------- add to cart */
  var busy = false;
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      if (!r.ok) { var er = new Error('cart ' + r.status); er.status = r.status; throw er; }
      return r.json();
    });
  }
  function setBusy(on) {
    d.querySelectorAll('[data-oa-buy]').forEach(function (b) {
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }
  function showErr(btn) {
    var box = btn && btn.closest ? btn.closest('[data-oa-err-scope]') : null;
    var errs = box ? box.querySelectorAll('[data-oa-err]') : d.querySelectorAll('.oa-sheet.is-open [data-oa-err]');
    if (!errs.length) errs = d.querySelectorAll('[data-oa-err]');
    errs.forEach(function (el) { if (C.errText && !el.textContent.trim()) el.textContent = C.errText; el.classList.add('is-on'); });
    if (btn && btn.classList) { btn.classList.remove('is-err'); void btn.offsetWidth; btn.classList.add('is-err'); }
  }
  /* Drawer renewal line (page-scoped; oa.js loads only on the oa templates): one plain
     "[price] today, then [price] every 30 days" line right above the drawer's checkout button. */
  function drawerTerms() {
    if (!C.terms) return;
    var n = 0, t = setInterval(function () {
      var co = d.querySelector('.bbfix-cart__co');
      if (co) {
        clearInterval(t);
        if (!co.parentNode.querySelector('.oa-drawer-terms')) {
          var p = d.createElement('p');
          p.className = 'oa-drawer-terms';
          p.textContent = C.terms;
          co.parentNode.insertBefore(p, co);
        }
      } else if (++n > 10) clearInterval(t);
    }, 100);
  }
  /* Drawer anchor (audit R3): the bbfix drawer prices the bundle against its catalog price
     ($66.64 struck, "$26.66 Off"), not the page's offer ($132.99, you save $93.01). On this page
     only, restate the page's numbers on the paid line and the foot. Applied only while the drawer
     holds exactly the offer (subtotal = the offer price and the first card is that price), so a
     qty change falls back to the drawer's own math. Every write is equality-guarded and one
     observer re-applies after each renderCart (catalog refine, qty, gift changes). The sampler's
     $0.00 <s>$4.97</s> and the promo line are never touched. */
  function anchorApply(cart) {
    if (!C.cmp || !C.save || !C.sub) return;
    var tot = cart.querySelector('[data-ctot]');
    var ciw = cart.querySelector('.bbfix-ciw');
    var pr = ciw ? ciw.querySelector('.bbfix-ci__price') : null;
    if (!tot || !pr || tot.textContent.trim() !== C.sub) return;
    if (pr.textContent.trim().indexOf(C.sub) !== 0) return;
    var s = pr.querySelector('s');
    if (!s) { pr.appendChild(d.createTextNode(' ')); s = d.createElement('s'); pr.appendChild(s); }
    if (s.textContent !== C.cmp) s.textContent = C.cmp;
    var was = cart.querySelector('[data-cwas]'), off = cart.querySelector('[data-coff]');
    if (was) {
      if (was.textContent !== C.cmp) was.textContent = C.cmp;
      if (was.style.display) was.style.display = '';
    }
    if (off) {
      var ot = C.save + ' Off';
      if (off.textContent !== ot) off.textContent = ot;
      if (off.style.display) off.style.display = '';
    }
  }
  function drawerAnchor() {
    if (!C.cmp || !C.save) return;
    var n = 0, t = setInterval(function () {
      var cart = d.querySelector('.bbfix-cart');
      if (cart) {
        clearInterval(t);
        anchorApply(cart);
        if (!cart.__oaAnchor && window.MutationObserver) {
          cart.__oaAnchor = true;
          new MutationObserver(function () { anchorApply(cart); })
            .observe(cart, { childList: true, subtree: true, characterData: true });
        }
      } else if (++n > 30) clearInterval(t);
    }, 100);
  }
  function buy(btn) {
    if (busy) return Promise.resolve(false);
    if (!C.vid) { showErr(btn); return Promise.resolve(false); }
    busy = true;
    setBusy(true);
    d.querySelectorAll('[data-oa-err]').forEach(function (el) { el.classList.remove('is-on'); });

    var main = { id: C.vid, quantity: 1, properties: { _hbo_src: srcValue() } };
    if (C.plan) main.selling_plan = C.plan;
    var gifts = C.gifts.map(function (g) { return { id: g, quantity: 1 }; });
    var full = [main].concat(gifts);
    if (C.sticks) full.push({ id: C.sticks, quantity: 1, properties: { _pc_gift: 'sticks' } });
    var noSampler = [main].concat(gifts);

    function add(items) { return post('/cart/add.js', { items: items }); }
    /* 422 = something in the request cannot be added (sampler stocked out or unpublished, a gift
       variant gone). The sale must not die with it: drop the sampler, then keep the bundle alone. */
    function on422(next) {
      return function (e) { if (e && e.status === 422 && next) return next(); throw e; };
    }
    /* checkout pages: the store drawer must not open on the add, the shopper goes to /checkout. */
    if (C.checkout === true) window.__BBFIX_NO_AUTOOPEN = true;
    var chain = C.clear === false ? Promise.resolve() : post('/cart/clear.js');
    return chain
      .then(function () {
        return add(full)
          .catch(on422(C.sticks ? function () { return add(noSampler); } : null))
          .catch(on422(gifts.length ? function () { return add([main]); } : null));
      })
      .then(function () {
        /* checkout pages: keep the button busy (no double add) and leave for checkout. */
        if (C.checkout === true) { window.location.href = '/checkout'; return true; }
        busy = false;
        setBusy(false);
        closeLayer(true);
        if (typeof window.__BBFIX_OPEN === 'function') { window.__BBFIX_OPEN(); drawerTerms(); drawerAnchor(); }
        else if (typeof window.__BBFIX_SHOWCART === 'function') window.__BBFIX_SHOWCART();
        else window.location.href = '/checkout';
        return true;
      })
      .catch(function () {
        busy = false;
        setBusy(false);
        showErr(btn);
        return false;
      });
  }
  window.__OA_BUY = buy;
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; setBusy(false); } });

  /* ---------------- layers: the offer sheet and modals share one manager (one open at a time). */
  var layer = null, opener = null, closeT = 0;
  var FOCUS = 'a[href], button:not([disabled]), input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  function focusables(root) {
    return [].filter.call(root.querySelectorAll(FOCUS), function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
  }
  function openLayer(el, from) {
    if (!el) return;
    if (layer && layer !== el) closeLayer(true);
    clearTimeout(closeT);
    if (el.parentNode !== d.body) d.body.appendChild(el);
    layer = el;
    opener = from || d.activeElement;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    html.classList.add('oa-lock');
    void el.offsetWidth;
    el.classList.add('is-open');
    var panel = el.querySelector('.oa-layer__panel');
    if (panel) panel.scrollTop = 0;
    var x = el.querySelector('.oa-layer__x') || focusables(el)[0];
    if (x) try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); }
    liftCookie();
  }
  function closeLayer(instant) {
    if (!layer) return;
    var el = layer;
    layer = null;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    html.classList.remove('oa-lock');
    var done = function () { if (!el.classList.contains('is-open')) el.hidden = true; };
    if (instant === true) done(); else closeT = setTimeout(done, 260);
    if (opener && opener.focus && instant !== true) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
    liftCookie();
  }
  function sheetEl() { return d.getElementById('oa-sheet'); }
  function openSheet(from) {
    var s = sheetEl();
    if (s) { openLayer(s, from); return; }
    /* No sheet on the page: fall back to the buy box, else buy straight away. */
    var box = d.getElementById('oa-buy');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else buy(from);
  }
  window.__OA_SHEET = { open: openSheet, close: closeLayer };
  window.__OA_MODAL = { open: function (id, from) { openLayer(d.getElementById(id), from); }, close: closeLayer };

  d.addEventListener('keydown', function (e) {
    if (!layer) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeLayer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(layer);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!layer.contains(d.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* One delegated click handler for every data-oa-* control (bubble phase, after the tagger). */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-oa-buy]');
    if (b) { e.preventDefault(); buy(b); return; }
    var s = t.closest('[data-oa-sheet]');
    if (s) { e.preventDefault(); openSheet(s); return; }
    var m = t.closest('[data-oa-modal-open]');
    if (m) { e.preventDefault(); openLayer(d.getElementById(m.getAttribute('data-oa-modal-open')), m); return; }
    var c = t.closest('[data-oa-close]');
    if (c && layer && layer.contains(c)) { e.preventDefault(); closeLayer(); }
  });
  /* Keyboard for non-button openers (a div with role=button). */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.matches || t.matches('button, a, summary, input, textarea')) return;
    if (t.matches('[data-oa-buy], [data-oa-sheet], [data-oa-modal-open]')) { e.preventDefault(); t.click(); }
  });

  /* ---------------- sticky bar: CSS shows it after 3s until this runs; from here it is shown
     whenever neither the hero CTA nor the #oa-buy CTA is fully in the viewport. */
  function stickyInit() {
    var root = d.querySelector('.oa-stk');
    if (!root) return;
    /* pad the brand band for browsers without :has() (see oa.css) */
    html.classList.add('oa-has-stk');
    if (!root.classList.contains('oa-stk--mob')) html.classList.add('oa-has-stk-d');
    var bar = root.querySelector('.oa-stk__bar');
    var targets = [d.getElementById('oa-hero-cta'), d.getElementById('oa-buy-cta')].filter(Boolean);
    if (!targets.length || !bar) return; /* stay in CSS mode */
    root.classList.remove('oa-stk--css');
    root.classList.add('oa-stk--js');
    var on = null, raf = 0;
    function fullyIn(el) {
      var r = el.getBoundingClientRect();
      if (!r.height && !r.width) return false;
      var vh = window.innerHeight || html.clientHeight;
      return r.top >= 0 && r.bottom <= vh;
    }
    function check() {
      raf = 0;
      var show = !targets.some(fullyIn);
      if (show === on) return;
      on = show;
      root.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      setTimeout(liftCookie, 240);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('pageshow', queue);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(queue, { threshold: [0, 0.5, 1] });
      targets.forEach(function (t) { io.observe(t); });
    }
    check();
  }

  /* ---------------- quiet cookie icon (port of hbo-cookie-icon): keep Pandectes' reopen icon above
     the sticky bar. The banner close itself runs inline from oa-head. */
  function liftCookie() {
    var rv = d.querySelector('.cc-revoke');
    if (!rv) return;
    var root = d.querySelector('.oa-stk');
    var bar = root && root.querySelector('.oa-stk__bar');
    var up = false;
    if (bar) {
      var cs = window.getComputedStyle(bar);
      up = cs.visibility === 'visible' && +cs.opacity > 0.5;
    }
    var want = (up ? Math.round(bar.getBoundingClientRect().height) + 10 : 15) + 'px';
    if (rv.style.bottom !== want) rv.style.bottom = want;
  }
  window.__OA_LIFT = liftCookie;
  window.addEventListener('scroll', function () { if (!liftCookie.q) { liftCookie.q = 1; setTimeout(function () { liftCookie.q = 0; liftCookie(); }, 200); } }, { passive: true });
  setTimeout(liftCookie, 3400);

  /* ---------------- accordion: [data-oa-acc] wraps items; each [data-oa-acc-btn] toggles the element
     named by its aria-controls (or its next sibling). data-oa-acc="one" keeps one open at a time. */
  function accInit(scope) {
    (scope || d).querySelectorAll('[data-oa-acc]').forEach(function (acc) {
      if (acc.__oa) return;
      acc.__oa = true;
      var one = acc.getAttribute('data-oa-acc') === 'one';
      function panelOf(btn) {
        var id = btn.getAttribute('aria-controls');
        return id ? d.getElementById(id) : btn.nextElementSibling;
      }
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-oa-acc-btn]');
        if (!btn || !acc.contains(btn)) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (one && open) {
          acc.querySelectorAll('[data-oa-acc-btn][aria-expanded="true"]').forEach(function (o) {
            if (o === btn) return;
            o.setAttribute('aria-expanded', 'false');
            var p = panelOf(o); if (p) p.hidden = true;
          });
        }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var p = panelOf(btn);
        if (p) p.hidden = !open;
      });
    });
  }
  window.__OA_ACC = accInit;

  /* ---------------- swiper: [data-oa-swipe] holds a [data-oa-track] (native scroll-snap, so touch
     and trackpad just work), optional [data-oa-prev] / [data-oa-next] and a [data-oa-dots] box.
     Mouse drag on desktop via pointer events. Slides may carry <img data-oa-src> for lazy images:
     the current slide and its neighbours get their real src. Fires "oa:slide" {detail:{index}}. */
  function swipe(el) {
    if (!el) return null;
    if (el.__oaSwipe) return el.__oaSwipe;
    var track = el.querySelector('[data-oa-track]');
    if (!track) return null;
    var slides = function () { return [].slice.call(track.children); };
    var prev = el.querySelector('[data-oa-prev]');
    var next = el.querySelector('[data-oa-next]');
    var dotsBox = el.querySelector('[data-oa-dots]');
    var idx = 0, raf = 0;
    function load(i) {
      var s = slides();
      [i - 1, i, i + 1].forEach(function (k) {
        var sl = s[k];
        if (!sl) return;
        sl.querySelectorAll('[data-oa-src]').forEach(function (img) {
          img.loading = 'eager';
          img.src = img.getAttribute('data-oa-src');
          if (img.hasAttribute('data-oa-srcset')) img.srcset = img.getAttribute('data-oa-srcset');
          img.removeAttribute('data-oa-src');
        });
      });
    }
    function current() {
      var s = slides(), left = track.scrollLeft, best = 0, bd = Infinity;
      var base = s.length ? s[0].offsetLeft : 0;
      s.forEach(function (sl, i) { var dd = Math.abs(sl.offsetLeft - base - left); if (dd < bd) { bd = dd; best = i; } });
      /* at the end of the track, the last slide counts as current */
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = s.length - 1;
      return best;
    }
    function paint() {
      var s = slides();
      if (dotsBox) [].forEach.call(dotsBox.children, function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= s.length - 1;
      load(idx);
    }
    function go(i) {
      var s = slides();
      if (!s.length) return;
      i = Math.max(0, Math.min(s.length - 1, i));
      track.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
      if (i !== idx) { idx = i; paint(); el.dispatchEvent(new CustomEvent('oa:slide', { detail: { index: idx } })); }
    }
    if (dotsBox && !dotsBox.children.length) {
      slides().forEach(function (_, i) {
        var b = d.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(b);
      });
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var i = current();
        if (i !== idx) { idx = i; paint(); el.dispatchEvent(new CustomEvent('oa:slide', { detail: { index: idx } })); }
      });
    }, { passive: true });
    /* mouse drag (touch uses native scrolling) */
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; track.classList.add('is-drag'); }
      if (drag.moved) track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      track.classList.remove('is-drag');
      if (moved) {
        go(current());
        /* swallow the click that ends a drag (and only that one) */
        var k = function (ev) { ev.stopPropagation(); ev.preventDefault(); track.removeEventListener('click', k, true); };
        track.addEventListener('click', k, true);
        setTimeout(function () { track.removeEventListener('click', k, true); }, 60);
      }
    });
    paint();
    var api = { go: go, index: function () { return idx; }, count: function () { return slides().length; }, el: el };
    el.__oaSwipe = api;
    return api;
  }
  window.__OA_SWIPE = swipe;

  /* ---------------- lazy video: <video data-oa-lazyvideo data-src="..." muted playsinline loop>
     gets its src when it nears the viewport, plays muted, and pauses off screen. Optional
     data-oa-loop-start / data-oa-loop-end (seconds) loop a short clip out of a longer file. */
  function lazyVideos() {
    var vids = d.querySelectorAll('video[data-oa-lazyvideo]');
    if (!vids.length) return;
    function arm(v) {
      if (v.__oa) return;
      v.__oa = true;
      var ls = parseFloat(v.getAttribute('data-oa-loop-start')) || 0;
      var le = parseFloat(v.getAttribute('data-oa-loop-end')) || 0;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      if (le > ls) {
        v.addEventListener('loadedmetadata', function () { try { v.currentTime = ls; } catch (e) {} });
        v.addEventListener('timeupdate', function () { if (v.currentTime >= le) { try { v.currentTime = ls; } catch (e) {} } });
      }
      v.src = v.getAttribute('data-src');
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(arm); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.__oa) arm(v); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (v.__oa && !v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) {
      /* eager hero video waits for window load so the poster paints first */
      if (v.hasAttribute('data-oa-after-load') && d.readyState !== 'complete') {
        window.addEventListener('load', function () { io.observe(v); });
      } else io.observe(v);
    });
  }

  /* ---------------- image warm-up: native lazy starts late on iOS, and a lazy img inside a horizontal
     track only loads once it is swiped into view, so cards painted blank and popped in. Once a lazy
     img (or a whole swipe track) is within ~2 screens of the viewport, fill its data-oa-src and flip
     it to eager. Hidden modals never intersect, so they keep native lazy until opened. */
  function warmImages() {
    function fill(img) {
      img.loading = 'eager';
      var s = img.getAttribute('data-oa-src');
      if (!s) return;
      img.src = s;
      if (img.hasAttribute('data-oa-srcset')) img.srcset = img.getAttribute('data-oa-srcset');
      img.removeAttribute('data-oa-src');
    }
    var targets = [].slice.call(d.querySelectorAll('.oa [data-oa-track]'));
    d.querySelectorAll('.oa img[loading="lazy"]').forEach(function (img) {
      if (!img.closest('[data-oa-track]')) targets.push(img);
    });
    function warm(t) {
      if (t.tagName === 'IMG') fill(t); else t.querySelectorAll('img').forEach(fill);
    }
    if (!('IntersectionObserver' in window)) { targets.forEach(warm); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        warm(en.target);
      });
    }, { rootMargin: '1600px 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  function boot() {
    readConfig();
    stickyInit();
    accInit();
    d.querySelectorAll('[data-oa-swipe]').forEach(swipe);
    warmImages();
    lazyVideos();
    /* the sheet lives at the end of body so no section's stacking context can trap it */
    var s = sheetEl();
    if (s && s.parentNode !== d.body) d.body.appendChild(s);
    d.querySelectorAll('.oa-modal[data-oa-portal]').forEach(function (m) { if (m.parentNode !== d.body) d.body.appendChild(m); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
